export enum ApiKeyNamesEnum {
    ETA_ENGINE = 'x-consumer-api-key',
    STORK = 'x-stork-admin-apikey',
    STORK_CLIENT = 'x-stork-apikey',
    RACOON = 'x-racoon-admin-apikey',
    DOLPHIN = 'x-dolphin-admin-apikey',
    OTP_SERVICE = 'x-otp-service-admin-apikey',
}
